import axios from "axios";
import { BASE_URL } from "../utils/urls";

export const login = async (email, password) => {
  const data = JSON.stringify({
    email,
    password,
  });
  const res = await axios.post(`${BASE_URL}/login`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return res.data;
};

export const resendVerificationEmail = async (email) => {
  const data = JSON.stringify({
    email,
  });
  const res = await axios.post(`${BASE_URL}/resend-verification-email`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return res.data;
};

export const getCaptcha = async () => {
  const res = await axios.get(`${BASE_URL}/captcha`);
  return res.data;
};

export const logout = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const res = await axios.post(`${BASE_URL}/logout`, {}, config);
  return res.data;
};

export const register = async (
  name,
  email,
  password,
  captcha,
  captchaToken,
  phone,
  countryCode
) => {
  const data = JSON.stringify({
    name,
    email,
    password,
    captcha,
    captcha_token: captchaToken,
    phone: `+${countryCode} ${phone}`,
  });
  const res = await axios.post(`${BASE_URL}/signup`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return res.data;
};

export const googleLogin = async (token) => {
  const data = JSON.stringify({
    token,
  });
  const res = await axios.post(`${BASE_URL}/google-login`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return res.data;
};

export const studentregister = async (
  name,
  email,
  password,
  captcha,
  captchaToken,
  phone,
  countryCode
) => {
  const data = JSON.stringify({
    name,
    email,
    password,
    captcha,
    captcha_token: captchaToken,
    phone: `+${countryCode} ${phone}`,
  });
  const res = await axios.post(`${BASE_URL}/student-signup`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return res.data;
};

export const studentgoogleLogin = async (token) => {
  const data = JSON.stringify({
    token,
  });
  const res = await axios.post(`${BASE_URL}/student-google-login`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return res.data;
};
